export default "__VITE_ASSET__XTSwGQUb__"